// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Box,
  Breadcrumbs,
  Container,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';

export function ProjectDetailsSkeleton() {
  return (
    <Container maxWidth="xl">
      <Stack marginTop={3} paddingX={3}>
        <Breadcrumbs separator="›">
          <Skeleton variant="text" width={60} />
          <Skeleton variant="text" width={120} />
        </Breadcrumbs>
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        paddingX={{ xs: 1, md: 3 }}
        marginTop={2}
      >
        <Skeleton variant="text" width={200} height={40} />
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rectangular" width={100} height={36} />
          <Skeleton variant="rectangular" width={110} height={36} />
          <Skeleton variant="rectangular" width={80} height={36} />
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        spacing={3}
        paddingX={{ xs: 1, md: 3 }}
      >
        <Stack useFlexGap flexGrow={1} spacing={1}>
          <Box
            gap={1}
            display="grid"
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            }}
          >
            {/* Date Range Section */}
            <Box>
              <Skeleton variant="text" width={80} height={20} sx={{ mb: 1 }} />
              <Skeleton variant="text" width={150} height={24} />
              <Skeleton variant="text" width={120} height={20} />
            </Box>

            {/* Project Details Section */}
            <Box
              rowGap={1}
              columnGap={2}
              display="grid"
              gridTemplateColumns="auto 1fr"
              alignSelf="start"
            >
              <Typography variant="subtitle2" marginTop={0.5}>
                <Skeleton variant="text" width={100} />
              </Typography>
              <Skeleton variant="text" width={120} />

              <Typography variant="subtitle2" marginTop={0.5}>
                <Skeleton variant="text" width={90} />
              </Typography>
              <Skeleton variant="text" width={100} />

              <Typography variant="subtitle2" marginTop={0.5}>
                <Skeleton variant="text" width={70} />
              </Typography>
              <Skeleton variant="text" width={140} />

              <Typography variant="subtitle2" marginTop={0.5}>
                <Skeleton variant="text" width={70} />
              </Typography>
              <Skeleton variant="text" width={160} />
            </Box>

            {/* Financial and Description Section */}
            <Box
              rowGap={1}
              columnGap={2}
              display="grid"
              gridTemplateColumns="auto 1fr"
              gridTemplateRows="auto 1fr"
            >
              <Stack direction="row" alignItems="center" marginTop={0.5}>
                <Skeleton variant="text" width={40} />
              </Stack>
              <Skeleton variant="text" width={80} />

              <Typography variant="subtitle2" marginTop={0.5}>
                <Skeleton variant="text" width={90} />
              </Typography>
              <Skeleton variant="text" width={100} />

              <Typography variant="subtitle2">
                <Skeleton variant="text" width={80} />
              </Typography>
              <Skeleton variant="rectangular" width="100%" height={60} />
            </Box>
          </Box>
        </Stack>
      </Stack>

      <Stack paddingX={{ xs: 1, md: 3 }} spacing={2} marginY={3}>
        <Stack direction="row" spacing={2} marginX={1}>
          <Skeleton variant="text" width={80} height={32} />
          <Skeleton variant="text" width={60} height={32} />
          <Skeleton variant="text" width={90} height={32} />
          <Skeleton variant="text" width={100} height={32} />
          <Skeleton variant="text" width={120} height={32} />
          <Skeleton variant="text" width={80} height={32} />
          <Skeleton variant="text" width={70} height={32} />
        </Stack>

        <Stack spacing={2}>
          <Skeleton variant="rectangular" width="100%" height={200} />
          <Stack spacing={1}>
            <Skeleton variant="text" width="80%" height={24} />
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="70%" height={20} />
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
}
